// extracted by mini-css-extract-plugin
export default {"root":"DayCalendar_root__+cnyM","empty":"DayCalendar_empty__U3tKz"};